import React from 'react';

var AnnouncerContext = React.createContext();

export default AnnouncerContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-aria-live/es/modules/AnnouncerContext.js
// module id = 138
// module chunks = 0